import { isNumericGuard } from "utils/dataManipulation";

import type { IfcScheduleProgress, IfcScheduleProgressEntities, IfcScheduleProgressPhase } from "../model/types";

import { ALTERNAIVE_VALUE_FOR_NULL_INSERTIONS, SCHEDULE_ENTITY_CONFIG } from "./configs";

export const hasScheduleProgress = (progress?: IfcScheduleProgress | null): boolean => {
  if (!progress) return false;
  if (progress.phase) return true;
  return SCHEDULE_ENTITY_CONFIG.some((config) => progress[config.totalKey] != null);
};

export const getEntityPercent = (inserted: number | undefined, total: number | undefined): number | undefined => {
  if (!isNumericGuard(inserted) || !isNumericGuard(total)) return;
  return Math.min(100, Math.round((inserted / total) * 100));
};

export const isPhaseActive = (phase: IfcScheduleProgressPhase | undefined, entityPhase: IfcScheduleProgressPhase) =>
  phase === entityPhase;

export const fillScheduleProgressEmptyValues = (progress: IfcScheduleProgressEntities): IfcScheduleProgressEntities => {
  return SCHEDULE_ENTITY_CONFIG.reduce(
    (acc, config) => {
      acc[config.insertedKey] = progress[config.insertedKey] ?? ALTERNAIVE_VALUE_FOR_NULL_INSERTIONS;
      return acc;
    },
    { ...progress }
  );
};
